export default "__VITE_ASSET__af58c8c0__"